import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { PERSISTED_STATE_KEY } from '@/util/constants'

import appEvent from './modules/app-event'
import auth from './modules/auth'
import common from './modules/common'
import login from './modules/login'
import contract from './modules/contract'
import contractPack from './modules/contract-pack'
import purchase from './modules/purchase'
import payment from './modules/payment'
import cancellation from './modules/cancellation'
import trial from './modules/trial'
import trialRegistration from './modules/trial-registration'
import dashboard from './modules/dashboard'
import bookList from './modules/book-list'
import documentDownloadsList from './modules/document-downloads-list'
import knowledge from './modules/knowledge'
import news from './modules/news'
import note from './modules/note'
import noteSelect from './modules/note-select'
import noteUserPermissionsEdit from './modules/note-user-permissions-edit'
import profile from './modules/profile'
import print from './modules/print'
import qa from './modules/qa'
import qaRelatedInfo from './modules/qa-related-info'
import searchCondition from './modules/search-condition'
import searchHistory from './modules/search-history'
import tag from './modules/tag'
import inquiry from './modules/inquiry'
import estimateFinal from './modules/estimate-final'
import passwordReminder from './modules/password-reminder'
import myLink from './modules/my-link'
import browsingHistory from './modules/browsing-history'
import users from './modules/users'
import search from './modules/search'
import searchUI from './modules/search-ui'
import file from './modules/file'
import bookmark from './modules/bookmark'
import alert from './modules/alert'
import viewLater from './modules/view-later'
import guide from './modules/guide'
import precedent from './modules/precedent'
import newApplication from './modules/new-application'

Vue.use(Vuex)

const saveStoragePath = [
  'appEvent.closedCount', // 資料検索ウィンドウを閉じた時に、window.addEventListener('storage', function)の処理を発動させるための設定
  'auth.token', // ログイン情報などを保持
  'auth.refreshToken', // ログイン情報などを保持
  'auth.exchangeToken', // 統合基盤連携用exchangeTokenを保持
  'auth.lastDate', // ログイン情報などを保持
  'profile', // 複数コンポーネントで使用されるため保持
  'search', // 同画面での遷移の場合、リロード処理となるため保持しておく。資料検索画面に渡す場合にも使用
  'common.systemErrorInFullScreen.title', // 全画面エラー：リロードした場合も正常に動作させるため
  'common.systemErrorInFullScreen.text', // 全画面エラー：リロードした場合も正常に動作させるため
  'qa.bookId', // リロードした場合も正常に動作させるため
  'qa.bookName', // リロードした場合も正常に動作させるため
  'qa.qaId', // リロードした場合も正常に動作させるため
  'qa.searchIndexId', // リロードした場合も正常に動作させるため
  'qa.revisionName', // リロードした場合も正常に動作させるため
  'qa.bookRevisionId', // リロードした場合も正常に動作させるため
  'qa.prev_url', // リロードした場合も正常に動作させるため
  'knowledge.prev_url', // リロードした場合も正常に動作させるため
  'payment', // 支払方法保存用
  'precedent.tab', // 資料検索：リロード対応用
  'precedent.bookId', // 資料検索：リロード対応用
  'precedent.themeId', // 資料検索：リロード対応用
  'precedent.themeName', // 資料検索：リロード対応用
  'precedent.detailId', // 資料検索：リロード対応用
  'precedent.bookId', // 資料検索：リロード対応用
  'precedent.bookRevisionId', // 資料検索：リロード対応用
  'precedent.previewBookRevisionId', // 資料検索：管理画面プレビュー用
  'precedent.bookName', // 資料検索：書籍名：別ウィンドウに渡す
  'precedent.subTitle', // 資料検索：検索タイトル：別ウィンドウに渡す
  'precedent.searchSetting', // 資料検索：設定
  'precedent.searchParams', // 資料検索：検索条件
  'inquiry', // お見積もり・トライアル・お問い合わせ・新規契約申込
  'newApplication' // 新規契約申込
]

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    appEvent: appEvent,
    auth: auth,
    common: common,
    login: login,
    contract: contract,
    contractPack: contractPack,
    purchase: purchase,
    payment: payment,
    cancellation: cancellation,
    trial: trial,
    trialRegistration: trialRegistration,
    dashboard: dashboard,
    bookList: bookList,
    documentDownloadsList: documentDownloadsList,
    knowledge: knowledge,
    news: news,
    note: note,
    noteSelect: noteSelect,
    noteUserPermissionsEdit: noteUserPermissionsEdit,
    profile: profile,
    print: print,
    qa: qa,
    qaRelatedInfo: qaRelatedInfo,
    searchCondition: searchCondition,
    searchHistory: searchHistory,
    tag: tag,
    inquiry: inquiry,
    estimateFinal: estimateFinal,
    passwordReminder: passwordReminder,
    myLink: myLink,
    browsingHistory: browsingHistory,
    users: users,
    search: search,
    searchUI: searchUI,
    file: file,
    bookmark: bookmark,
    alert: alert,
    viewLater: viewLater,
    guide: guide,
    precedent: precedent,
    newApplication: newApplication
  },
  plugins: [createPersistedState({
    key: PERSISTED_STATE_KEY,
    paths: saveStoragePath
    // storage: window.sessionStorage
  })]
})
